// extracted by mini-css-extract-plugin
export default {"button":"Gq-z","reviewSort":"Hq-z"};